<!-- 菜单：上传图片 /pages/dev/uploadImageManage -->
<template>
  <div class="upload-image-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>上传图片</span>
      </div>

      <el-upload
        class="upload-demo"
        action="#"
        :auto-upload="false"
        :on-change="handleChange"
        :on-remove="handleRemove"
        :file-list="fileList"
        :limit="10"
        list-type="picture-card"
        accept="image/*"
      >
        <i class="el-icon-plus"></i>
      </el-upload>

      <div class="upload-urls">
        <div class="urls-title">图片URL地址：</div>
        <el-input
          type="textarea"
          v-model="urlList"
          :rows="10"
          placeholder="上传图片后将显示URL地址"
          readonly
        ></el-input>
        <el-button
          type="primary"
          size="small"
          class="copy-btn"
          :disabled="!urlList"
          @click="copyUrls"
        >
          复制所有URL
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'UploadImageManage',
  data() {
    return {
      fileList: [],
      urlList: []
    }
  },
  methods: {
    async handleChange(file) {
      const formData = new FormData()
      formData.append('uploadFile', file.raw)
      formData.append('communityId', '-1')

      try {
        const res = await request({
          url: '/callComponent/upload/uploadFile/uploadImage',
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })

        if (res && res.url) {
          const uploadResult = {
            name: file.name,
            url: res.url,
            fileId: res.fileId
          }
          this.fileList.push(uploadResult)
          this.urlList.push(res.url)
          this.urlList = [...this.urlList]
          this.$message.success('上传成功')
        }
      } catch (error) {
        this.$message.error(error.message || '上传失败')
      }
    },
    handleRemove(file) {
      const url = file.url
      if (url) {
        const index = this.urlList.indexOf(url)
        if (index > -1) {
          this.urlList.splice(index, 1)
          this.urlList = [...this.urlList]
        }
        const fileIndex = this.fileList.findIndex(f => f.url === url)
        if (fileIndex > -1) {
          this.fileList.splice(fileIndex, 1)
        }
      }
    },
    copyUrls() {
      if (!this.urlList.length) return

      const urlsText = this.urlList.join('\n')
      this.$copyText(urlsText).then(() => {
        this.$message.success('复制成功')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    }
  }
}
</script>

<style scoped>
.upload-image-container {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.upload-urls {
  margin-top: 20px;
}

.urls-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.copy-btn {
  margin-top: 10px;
}
</style>
